import React from 'react';
import {
  getTableRowCheckBox,
  returnCustomerAddressString,
  returnParcelProductInformation,
  returnParcelRescheduleInformation,
  returnParcelReturnScanInformation,
  returnParcelStatusInformation,
  returnParcelVehicleInformation,
} from '../../utils/table';
import {
  returnSchemeExcelDate,
  returnUserReadableDate,
} from '../../utils/datetime';
import { Badge } from '@themesberg/react-bootstrap';
import { getTripBadgeStatus } from '../../utils/trips';
import * as XLSX from 'xlsx';

export const replacementPendingTableColumns = (onRowSelect) => {
  return [
    {
      dataField: 'objectId',
      text: 'Select',
      formatter: (cell, row) => {
        return getTableRowCheckBox(onRowSelect, cell, row?.isSelected, false);
      },
    },
    {
      dataField: 'customerName',
      sort: true,
      text: 'Customer Info',
      formatter: (cell, row) => {
        return returnCustomerAddressString(cell, row?.mobileNo, 200, 30);
      },
    },
    {
      dataField: 'shippingAddress',
      sort: true,
      text: 'Customer Address',
      formatter: (cell, row) => {
        const customerAddress = `${row?.shippingAddress1}${row?.shippingAddress2}${row?.shippingAddress3}`;
        return returnCustomerAddressString(
          customerAddress,
          row?.shippingPincode,
          200,
          30
        );
      },
    },
    {
      dataField: 'invoiceNo',
      text: 'Invoice Details',
      formatter: (cell, row) => {
        return (
          <div className="d-block">
            <span className="fw-bold">{cell}</span>
            <div className="fw-normal">
              {new Date(row?.date).toLocaleDateString()}
            </div>
          </div>
        );
      },
    },
    {
      dataField: 'serialNo',
      text: 'Product Info',
      formatter: (cell, row) => {
        return returnParcelProductInformation(row);
      },
    },
    {
      dataField: 'status',
      text: 'Current Status',
      formatter: (cell, row) => {
        return returnParcelStatusInformation(row);
      },
    },
    {
      dataField: 'status',
      text: 'Received Info',
      formatter: (cell, row) => {
        return returnParcelReturnScanInformation(row);
      },
    },
    {
      dataField: 'tripInfo.vehicleNumber',
      text: 'Trip Info',
      formatter: (cell, row) => {
        return returnParcelVehicleInformation(row);
      },
    },
  ];
};

export const replacementPendingRegisterTableColumns = (onRowSelect) => {
  return [
    {
      dataField: 'objectId',
      text: 'Select',
      formatter: (cell, row) => {
        const isDisabled =
          !(
            row?.invoiceNo?.startsWith('RC/') ||
            row?.invoiceNo?.startsWith('PC/')
          ) && !row?.challanNumber;
        return getTableRowCheckBox(
          onRowSelect,
          cell,
          row?.isSelected,
          isDisabled
        );
      },
    },
    {
      dataField: 'customerName',
      sort: true,
      text: 'Customer Info',
      formatter: (cell, row) => {
        return returnCustomerAddressString(cell, row?.mobileNo, 200, 30);
      },
    },
    {
      dataField: 'shippingAddress',
      sort: true,
      text: 'Customer Address',
      formatter: (cell, row) => {
        const customerAddress = `${row?.shippingAddress1}${row?.shippingAddress2}${row?.shippingAddress3}`;
        return returnCustomerAddressString(
          customerAddress,
          row?.shippingPincode,
          200,
          30
        );
      },
    },
    {
      dataField: 'invoiceNo',
      text: 'Invoice Details',
      formatter: (cell, row) => {
        return (
          <div className="d-block">
            <span className="fw-bold">{cell}</span>
            <div className="fw-normal">
              {new Date(row?.date).toLocaleDateString()}
            </div>
          </div>
        );
      },
    },
    {
      dataField: 'challanNumber',
      text: 'Challan & New S.No',
      formatter: (cell, row) => {
        return (
          <div className="d-block">
            <span className="fw-bold">{cell}</span>
            <div className="fw-normal">
              {row?.newSerialNo ? `New Serial: ${row?.newSerialNo}` : ''}
            </div>
          </div>
        );
      },
    },
    {
      dataField: 'serialNo',
      text: 'Product Info',
      formatter: (cell, row) => {
        return returnParcelProductInformation(row);
      },
    },
    {
      dataField: 'status',
      text: 'Current Status',
      formatter: (cell, row) => {
        return returnParcelStatusInformation(row);
      },
    },
    {
      dataField: 'rescheduledBy',
      text: 'Resch. By',
      formatter: (cell, row) => {
        return returnParcelRescheduleInformation(row);
      },
    },
    {
      dataField: 'newDeliveryDate',
      text: 'New Del. Date',
      formatter: (cell, row) => {
        return (
          <div className="d-block">
            <div className="fw-normal">
              {row?.estimatedDeliveryDate
                ? returnUserReadableDate(row?.estimatedDeliveryDate)
                : ''}
            </div>
            <div className="fw-normal">
              {row?.remarks ? `Remarks: ${row?.remarks}` : ''}
            </div>
          </div>
        );
      },
    },
    {
      dataField: 'status',
      text: 'Received Info',
      formatter: (cell, row) => {
        return returnParcelReturnScanInformation(row);
      },
    },
    {
      dataField: 'tripInfo.vehicleNumber',
      text: 'Trip Info',
      formatter: (cell, row) => {
        return returnParcelVehicleInformation(row);
      },
    },
  ];
};

export const replacementReportColumns = () => {
  return [
    {
      dataField: 'date',
      text: 'Invoice Details',
      formatter: (cell, row) => {
        return (
          <>
            <div className="fw-bold">{row?.invoiceNo}</div>
            <div className="fw-normal">{returnUserReadableDate(cell)}</div>
            <div className="fw-normal">Serial No: {row?.serialNo}</div>
          </>
        );
      },
    },
    {
      dataField: 'originalInvoiceNo',
      text: 'Original Invoice',
      formatter: (cell, row) => {
        return (
          <>
            <div className="fw-bold">{cell}</div>
            <div className="fw-normal">
              {returnUserReadableDate(row?.invoiceDate)}
            </div>
          </>
        );
      },
    },
    {
      dataField: 'scannedAt',
      text: 'Return details',
      formatter: (cell, row) => {
        return (
          <>
            <div className="fw-normal">
              {new Date(cell).toLocaleDateString()}
              <div className="fw-normal">{row?.scannedBy}</div>
            </div>
          </>
        );
      },
    },
    {
      dataField: 'tripNumber',
      text: 'Trip Number',
    },
    {
      dataField: 'dispatchData',
      text: 'Vehicle Details',
      formatter: (cell, row) => {
        return (
          <>
            <div className="fw-normal">
              {cell?.vehicleDetails?.vehicleNumber}
            </div>
            <div className="fw-normal">{cell?.vehicleDetails?.driverName}</div>
          </>
        );
      },
    },
    {
      dataField: 'branch',
      text: 'Branch Details',
      formatter: (cell, row) => {
        return (
          <>
            <div className="fw-normal">Branch: {cell}</div>
            <div className="fw-normal">Target Branch: {row?.targetBranch}</div>
            <div className="fw-normal">Zone: {row?.zone}</div>
          </>
        );
      },
    },
    {
      dataField: 'replacementType',
      text: 'Replacement Type',
    },
    {
      dataField: 'status',
      text: 'Status',
      formatter: (cell, row) => {
        return (
          <Badge bg={getTripBadgeStatus(cell)} className="badge-lg">
            {cell}
          </Badge>
        );
      },
    },
  ];
};

export const replacementReportExport = (data) => {
  const result =
    data &&
    data?.map((item) => {
      return {
        InvoiceNo: item?.invoiceNo,
        InvoiceDate: returnSchemeExcelDate(item?.createdAt),
        SerialNo: item?.serialNo,
        OrderNo: item?.orderNo,
        ReplacementType: item?.replacementType,
        'Return Scanned Date': item?.scannedAt
          ? returnSchemeExcelDate(item?.scannedAt)
          : '',
        ScannedBy: item?.scannedBy,
        'Original Invoice': item?.originalInvoiceNo,
        'Original Invoice Date': item?.invoiceDate
          ? returnSchemeExcelDate(item?.invoiceDate)
          : '',
        TripNumber: item?.tripNumber,
        VehicleNumber: item?.dispatchData?.vehicleDetails?.vehicleNumber,
        DriverName: item?.dispatchData?.vehicleDetails?.driverName,
        Branch: item?.branch,
        TargetBranch: item?.targetBranch,
        Zone: item?.zone,
        'New Serial No': item?.newSerialNo,
        status: item?.status,
        Amount: item?.amount,
        CGST: item?.CGST,
        SGST: item?.SGST,
        IGST: item?.IGST,
        Product: item?.product,
        'Delivery Warehouse': item?.deliveryWarehouse,
        'Display/GT': item?.isDisplay,
        'Warehouse Code': item?.warehouseCode,
        'Van No': item?.itemNumber,
        BuyBack: item?.buyBack,
        'BuyBack Product': item?.buyBackProduct,
        'Customer Name': item?.customerName,
        'Shipping Pincode': item?.shippingPincode,
      };
    });
  const worksheet = XLSX.utils.json_to_sheet(result);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, 'Replacement Report');
  XLSX.writeFile(workbook, 'Replacement_Report.xlsx');
};
